import {useQuery} from '@tanstack/react-query';
import {settingsService} from '@/services/settingsService';

// query keys
export const settingsQueryKeys={
    all: ['settings'],
    list: () => [...settingsQueryKeys.all, 'list'],
}

// get all settings
export const useAllSettings=()=>{
    return useQuery({
        queryKey: settingsQueryKeys.list(),
        queryFn: ()=>settingsService.getAllSettings(),
    })
}


